import "./App.css";
// import "./css/style.css";
// import 'antd/dist/antd.css';
import "./index.css";
import React, { useMemo, useState, useEffect } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Navbar from "./components/navbar/TopNav.jsx";
import auth from "./services/authService";
import "react-toastify/dist/ReactToastify.css";
import "./antd.css";
import ProtectedRoute from "./components/common/protectedRoute";
// import 'antd/dist/antd.css';
import BranchContext from "./components/context/branch";
import PrivilegeContext from "./components/context/privilege";
import { getMemulist } from "./services/wms";
import UserContext from "./components/context/user";
import SetupContext from "./context/setup";
import SearchContext from "./context/searchContext";
import { PermissionContext } from "./context/permissionContext";
import { SessionContext } from "./context/sessionContext";
import Setup from "./components/navbar/setup";
import NotFound from "./components/notFound";
import Showdetail from "./components/wms/showdetail";
import LoginForm from "./components/session/loginForm";
import Logout from "./components/session/logout";
import RegisterUser from "./components/register/registerprofile";
import Weightreport from "./components/wms/weightlist";
import Search from "./components/search/searchFuction";
import Register from "./components/wms/register";
import Registermain from "./components/wms/registermain";
import registerlist from "./components/wms/registerlist";
import Reportchart from "./components/wms/reportchart";
import Woodchipmonitor from "./components/woodchip/woodchipmonitor";
import QueuePlanWood from "./components/queue/queueplan501";
import Woodmonitor from "./components/wms/woodmonitor";
import Plan from "./components/wms/plan";
import Stackedcolumnchart from "./components/chart/stackedcolumn";
import Queuewoodchip from "./components/wms/queuewoodchip";
import Reportsummary from "./components/wms/reportweightsum";
import Coalreceive from "./components/goodreceive/registerlist";
import CardQueueCall from "./components/wms/CardQueueCall";
import Renderdrivenprofile from "./components/wms/renderdrivenprofile";
import { StoreContextProvider } from "./components/context/store";
import useWindowDimensions from "./components/common/screenwidth";
import Showtruckover from "./components/wms/showtruckover";
import Managebranch from "./components/wms/managebranch";
import Queuemonitor from "./components/queue/queuemonitor";
import QueueActual from "./components/queue/queueactual";
import QueueActual501 from "./components/queue/queueactual501";
import { useHistory } from "react-router-dom";
import LPRreport from "./components/lpr/LPRreport";
import Manageface from "./components/wms/manageface";
import Reportpower from "./components/report/reportpower";
import Weightreportbranch from "./components/wms/weightreportbranch";
import Editbranch from "./components/management/editbranch";
import Editcar from "./components/management/editcar";
import Editcustormer from "./components/management/editcustomer";
import Modaleditcustomer from "./components/management/modaleditcustomer";
import Modaleditproduct from "./components/management/modaleditproduct";
import Cardeditproduct from "./components/management/cardeditproduct";
import Modalapprove from "./components/management/modalapprove";
import Approve from "./components/management/approve";
import Waitapprove from "./components/management/waitapprove";
import Allapprove from "./components/management/allapprove";
import Okapprove from "./components/management/okapprove";
import Notapprove from "./components/management/notapprove";
import Editdo from "./components/management/editdo";
import Modaleditdo from "./components/management/modaleditdo";
import Modalchangcustomer from "./components/management/modalchangcustomer";
import Changcustomer from "./components/management/changcustomer";
import Modaleditcar from "./components/management/modaleditcar";
import Editobjective from "./components/management/editobjective";
import Editqueue from "./components/queue/editqueue";
import Modaleditqueue from "./components/queue/modaleditqueue";
import Mainweigthscale from "./components/weigthscale/mainweigthscale";
import Requestall from "./components/weigthscale/requestall";
import Request from "./components/weigthscale/request";
import Viewrequest from "./components/weigthscale/viewrequest";
import Content from "./components/dashboard/dashboard";
import Registerhub from "./components/wms/registerhub";
import Editwood from "./components/management/editwood";
import Editdestination from "./components/management/editdestination";
import Editunlock from "./components/management/editunlock";
import Canclequeue from "./components/management/canclequeue";
import Myregister from "./components/management/myregister";
import Editstore from "./components/management/editstore";
import RegisterAccount from "./components/session/registeraccount";
import Ideltimeout from "./components/common/Idletimeout";

function App(props) {
  const [user, setuser] = useState("");
  const GlobalStateProvider = ({ children }) => {
    const handelOnChange = (event) => {
      setSearchtext(event);
    };
    const handelOnClick = (event) => {
      setIsOpen(event);
    };
    const handelOnChangeTheme = (event) => {
      setChangeThemen(event);
    };

    // user =  auth.getCurrentUser();
    //  setuser(auth.getCurrentUser)

    // useEffect(() => {
    //   const loadCurrentUser = async () => {
    //     setuser(auth.getCurrentUser);
    //   };
    //   loadCurrentUser();
    // }, []);

    const [permission, setPermission] = useState(auth.getPermission());
    const [currentBranch, setcurrentBranch] = useState({ _id: "", name: "" });

    const [searchtext, setSearchtext] = useState({ name: "", search: false });
    const [isOpen, setIsOpen] = useState(false);
    const [changeTheme, setChangeThemen] = useState({
      name: "",
      change: false,
    });
    useEffect(() => {
      const loadCurrentBranch = async () => {
        setcurrentBranch(auth.getCurrentBranch);
      };
      loadCurrentBranch();
    }, []);

    const handelSelectedBranch = (brandid) => {
      setcurrentBranch(brandid);
    };

    // useEffect(() => {
    //   // setPermission(auth.getPermission())
    //   console.log('permiss app3',permission,currentBranch)
    // }, []);

    // const {  setPermission } = useContext(PermissionContext);

    const [session, setSession] = useState(auth.getCurrentUser());

    const permissionValue = useMemo(
      () => ({ permission, setPermission }),
      [permission]
    );
    const sessionValue = useMemo(() => ({ session, setSession }), [session]);
    return (
      <BranchContext.Provider
        value={{ currentBranch, onSelected: handelSelectedBranch }}
      >
        <SetupContext.Provider value={{ isOpen, onChange: handelOnClick }}>
          <SearchContext.Provider
            value={{ searchtext, onChange: handelOnChange }}
          >
            <SessionContext.Provider value={sessionValue}>
              <PermissionContext.Provider value={permissionValue}>
                {children}
              </PermissionContext.Provider>
            </SessionContext.Provider>
          </SearchContext.Provider>
        </SetupContext.Provider>
      </BranchContext.Provider>
    );
  };

  const itemClick = (event) => {};

  return (
    <>
      <GlobalStateProvider>
        <ToastContainer />
        <Navbar
          user={user}
          //  loading ={loading}
          // menulist={onLoadMenuList}
          itemClick={itemClick}
        ></Navbar>
        <div className="container-fluid">
          <div className="row justify-content-center">
            <main
              role="main"
              className="container-fluid"
              style={{
                padding: "5px",
                marginTop: "70px",
                marginLeft: "5px",
                marginRight: "5px",
              }}
            >
              <Switch>
                {/* <Route path="/registeruser" component={RegisterUser} />; */}
                <ProtectedRoute path="/dashboard" exact component={Content} />
                {/* <ProtectedRoute
            path="/register/:id"
            exact
            render={(props) => <Register {...props} />}
          /> */}
                <ProtectedRoute
                  path="/register/:id"
                  exact
                  component={Registermain}
                />
                <ProtectedRoute path="/setup" exact component={Setup} />
                <ProtectedRoute path="/registerlist" component={registerlist} />
                <ProtectedRoute path="/lprrecord" component={LPRreport} />
                <ProtectedRoute path="/showdetail" component={Showdetail} />
                <ProtectedRoute path="/queueactual" component={QueueActual} />
                <ProtectedRoute path="/Reportchart" component={Reportchart} />
                <ProtectedRoute path="/plan" component={Plan} />
                <ProtectedRoute
                  path="/Stackedcolumnchart"
                  component={Stackedcolumnchart}
                />
                <ProtectedRoute path="/weightreport" component={Weightreport} />
                <ProtectedRoute
                  path="/woodchipmonitor"
                  component={Woodchipmonitor}
                />
                <ProtectedRoute
                  path="/woodmonitor"
                  component={QueueActual501}
                />
                <ProtectedRoute
                  path="/queuewoodchip"
                  component={QueuePlanWood}
                />
                <ProtectedRoute
                  path="/reportsumary"
                  component={Reportsummary}
                />
                <ProtectedRoute path="/receivecoal" component={Coalreceive} />
                <ProtectedRoute
                  path="/CardQueueCall"
                  component={CardQueueCall}
                />
                <ProtectedRoute
                  path="/Renderdrivenprofile"
                  component={Renderdrivenprofile}
                />
                <ProtectedRoute
                  path="/Showtruckover"
                  component={Showtruckover}
                />
                <ProtectedRoute path="/managebranch" component={Managebranch} />
                <ProtectedRoute path="/manageface" component={Manageface} />
                <ProtectedRoute path="/queuelist" component={Queuemonitor} />
                <ProtectedRoute
                  path="/Weightreportbranch"
                  component={Weightreportbranch}
                />
                <ProtectedRoute path="/registerhub" component={Registerhub} />
                <ProtectedRoute
                  path="/editcustomer"
                  component={Editcustormer}
                />
                <ProtectedRoute path="/editbranch" component={Editbranch} />
                <ProtectedRoute path="/reportpower" component={Reportpower} />
                <ProtectedRoute path="/editcar" component={Editcar} />
                <ProtectedRoute path="/modaleditcar" component={Modaleditcar} />
                <ProtectedRoute
                  path="/editcustomer"
                  component={Editcustormer}
                />
                <ProtectedRoute path="/editwood" component={Editwood} />
                <ProtectedRoute
                  path="/modaleditcustomer"
                  component={Modaleditcustomer}
                />
                <ProtectedRoute
                  path="/modaleditproduct"
                  component={Modaleditproduct}
                />
                <ProtectedRoute
                  path="/cardeditproduct"
                  component={Cardeditproduct}
                />
                <ProtectedRoute path="/editdo" component={Editdo} />
                <ProtectedRoute path="/modaleditdo" component={Modaleditdo} />
                <ProtectedRoute path="/modalapprove" component={Modalapprove} />
                <ProtectedRoute
                  path="/modalchangcustomer"
                  component={Modalchangcustomer}
                />
                <ProtectedRoute
                  path="/changcustomer"
                  component={Changcustomer}
                />
                <ProtectedRoute
                  path="/editobjective"
                  component={Editobjective}
                />
                <ProtectedRoute path="/editqueue" component={Editqueue} />
                <ProtectedRoute
                  path="/modaleditqueue"
                  component={Modaleditqueue}
                />
                <ProtectedRoute
                  path="/mainweigthscale"
                  component={Mainweigthscale}
                />
                <ProtectedRoute path="/request" component={Request} />
                <ProtectedRoute path="/requestall" component={Requestall} />
                <ProtectedRoute path="/approve" component={Approve} />
                <ProtectedRoute path="/allapprove" component={Allapprove} />
                <ProtectedRoute path="/waitapprove" component={Waitapprove} />
                <ProtectedRoute path="/okapprove" component={Okapprove} />
                <ProtectedRoute path="/notapprove" component={Notapprove} />
                <ProtectedRoute path="/viewrequest" component={Viewrequest} />
                <ProtectedRoute
                  path="/editdestination"
                  component={Editdestination}
                />
                <ProtectedRoute path="/editstore" component={Editstore} />
                <ProtectedRoute path="/editunlock" component={Editunlock} />
                <ProtectedRoute path="/canclequeue" component={Canclequeue} />
                <ProtectedRoute path="/myregister" component={Myregister} />
                <Route path="/registerAccount" component={RegisterAccount} />
                <Route path="/registeruser" component={RegisterUser} />;
                <Redirect from="/" exact to="/registerlist" />
                <Route path="/login" component={LoginForm} />
                <Route path="/ideltimeout" component={Ideltimeout} />
                Ideltimeout
                <ProtectedRoute path="/logout" exact component={Logout} />
                <ProtectedRoute path="/not-found" component={NotFound} />
                <Redirect to="/not-found" />
              </Switch>
            </main>
          </div>
        </div>
      </GlobalStateProvider>
    </>
  );
}

export default App;

// import "./App.css";
// import React, { Component, useEffect, useState } from "react";
// import SideMenu from "./components/sidebar/SideMenu";
// // import { menuItems } from "./components/sidebar/menuItemlist";
// import ProtectedRoute from "./components/common/protectedRoute";
// import NavBar from "./components/menu/navBarF";
// import {
//   BrowserRouter as Router,
//   Switch,
//   Route,
//   Redirect,
// } from "react-router-dom";

// import "react-toastify/dist/ReactToastify.css";
// import auth from "./services/authService";
// import BranchContext from "./components/context/branch";
// import PrivilegeContext from "./components/context/privilege";
// import { getMemulist } from "./services/wms";
// import UserContext from "./components/context/user";
// import { ToastContainer } from "react-toastify";
// import NotFound from "./components/notFound";
// import Showdetail from "./components/wms/showdetail";
// import LoginForm from "./components/session/loginForm";
// import Logout from "./components/session/logout";
// import RegisterUser from "./components/register/registerprofile";
// import Weightreport from "./components/wms/weightlist";
// import Search from "./components/search/searchFuction";
// import Register from "./components/wms/register";
// import registerlist from "./components/wms/registerlist";
// import Reportchart from "./components/wms/reportchart";
// import Woodchipmonitor from "./components/woodchip/woodchipmonitor";
// import QueuePlanWood from "./components/queue/queueplan501";
// import Woodmonitor from "./components/wms/woodmonitor";
// import Stackedcolumnchart from "./components/chart/stackedcolumn";
// import Queuewoodchip from "./components/wms/queuewoodchip";
// import Reportsummary from "./components/wms/reportweightsum";
// import Coalreceive from "./components/goodreceive/registerlist";
// import CardQueueCall from "./components/wms/CardQueueCall";
// import Renderdrivenprofile from "./components/wms/renderdrivenprofile";
// import { StoreContextProvider } from "./components/context/store";
// import useWindowDimensions from "./components/common/screenwidth";
// import Showtruckover from "./components/wms/showtruckover"
// import Managebranch from "./components/wms/managebranch"
// import Queuemonitor from "./components/queue/queuemonitor"
// import QueueActual from './components/queue/queueactual'
// import QueueActual501 from './components/queue/queueactual501'
// import { useHistory } from "react-router-dom";
// import LPRreport from "./components/lpr/LPRreport"
// import Manageface from "./components/wms/manageface"
// import Reportpower from "./components/report/reportpower"
// import Weightreportbranch from "./components/wms/weightreportbranch"
// import Editbranch from "./components/management/editbranch";
// import Editcar from "./components/management/editcar"
// import Editcustormer from "./components/management/editcustomer"
// import Modaleditcustomer from "./components/management/modaleditcustomer"
// import Modaleditproduct from "./components/management/modaleditproduct"
// import Cardeditproduct from "./components/management/cardeditproduct"
// import Modalapprove from "./components/management/modalapprove"
// import Approve from "./components/management/approve"
// import Waitapprove from "./components/management/waitapprove"
// import Allapprove from "./components/management/allapprove"
// import Okapprove from "./components/management/okapprove"
// import Notapprove from "./components/management/notapprove"
// import Cardeditdo from "./components/management/cardeditdo"
// import Modaleditdo from "./components/management/modaleditdo"
// import Modalchangcustomer from "./components/management/modalchangcustomer"
// import Changcustomer from "./components/management/changcustomer"
// import Modaleditcar from "./components/management/modaleditcar"
// import Editobjective from "./components/management/editobjective"
// import Editqueue from "./components/queue/editqueue"
// import Modaleditqueue from "./components/queue/modaleditqueue"
// import Mainweigthscale from "./components/weigthscale/mainweigthscale"
// import Requestall from "./components/weigthscale/requestall";
// import Request from "./components/weigthscale/request";
// import Viewrequest from "./components/weigthscale/viewrequest";

// // const mql = window.matchMedia(`(min-width: 992px)`);

// function App() {
//   // const [sidebarDocked, setsidebarDocked] = useState(mql.matches);
//   const [inactive, setInactive] = useState(true);
//   const [user, setuser] = useState("");
//   const [currentBranch, setcurrentBranch] = useState({ _id: "", name: "" });
//   const [sidebarOpen, setsidebarOpen] = useState(false);
//   const [menuItems, setmenuItems] = useState([]);
//   const history = useHistory();

//   const [privilege, setprivilege] = useState([]);

//   const { height, width, small } = useWindowDimensions();
//   useEffect(() => {
//     const loadCurrentBranch = async () => {
//       setcurrentBranch(auth.getCurrentBranch);
//     };
//     loadCurrentBranch();
//   }, []);

//   useEffect(() => {
//     const loadUser = async () => {
//       setuser(auth.getCurrentUser);
//     };
//     loadUser();
//   }, []);

//   const handelSelectedBranch = (brandid) => {
//     setcurrentBranch(brandid);
//   };
//   const handelOnChange = (event) => {
//     setprivilege(event);
//   };

//   const handleInactiveClick = (inactive) => {
//     setInactive(inactive);
//   };
//   const onLoadMenuList = (event) => {};
//   const toggleSideBar = () => {
//     setsidebarOpen(!sidebarOpen);
//   };
//   const itemClick = (event) => {
//     setmenuItems(event);
//     if (small) {
//       setsidebarOpen(false);
//     }
//   };

//   useEffect(() => {

//     if (!user) return;
//     if (!currentBranch) return;
//   const loadMenulist = async () => {

//     try {
//       const { data: result } = await getMemulist(currentBranch._id
//         );

//         if (result.status === "success") {
//           setmenuItems(result.data.menuItems);
//         }else if (result.status === "error"){

//           const urlGoBack = "logout";
//           setTimeout(history.replace(urlGoBack), 1000);
//         }
//     }catch (error) {
//       const urlGoBack = "logout";
//       setTimeout(history.replace(urlGoBack), 1000);

//     }

//   };
//   loadMenulist();
// }, [user, currentBranch,history]);

//  if (!(privilege)){
//     return <div>

//     </div>
//   }
//   return (
//     <StoreContextProvider>
//       <UserContext.Provider value={user}>
//         <PrivilegeContext.Provider
//           value = {{menuItems : menuItems ,onChange:handelOnChange}}
//         >
//           <BranchContext.Provider
//             value={{ currentBranch, onSelected: handelSelectedBranch }}
//           >
//             <ToastContainer />
//             <NavBar user={user} onSidebarToggle={toggleSideBar} />
//             <div className="App">
//               <Router>
//                 {user && (
//                   <SideMenu
//                     menulist={onLoadMenuList}
//                     itemClick={itemClick}
//                     windowsSize={width}
//                     sidebarOpen={sidebarOpen}
//                     onCollapse={(inactive) => {
//                       handleInactiveClick(inactive);
//                     }}
//                   />
//                 )}
//                 {user ? (
//                   <div
//                     className={`container1 ${
//                       inactive && sidebarOpen
//                         ? "inactive d-block"
//                         : inactive && !small
//                         ? "inactive d-block"
//                         : sidebarOpen && small
//                         ? "d-block"
//                         : !inactive && !sidebarOpen && small
//                         ? "hide "
//                         : inactive && !sidebarOpen && small
//                         ? "hide "
//                         : ""
//                     }`}
//                   >
//                     {menuItems &&
//                       menuItems.length > 0 &&
//                       menuItems.map((item, index) => {
//                         return (
//                           <Route key={index} path={item.to}>
//                             {/* <h1>{item.name}</h1> */}
//                           </Route>
//                         );
//                       })}

//                     {/* improvememt, not recorded in video, its just looping through menuItems
//           instead of hard coding all the routes */}
//                     {menuItems.map((item, index) => {

//                         return (
//                           <div key = {index}>
//                             <Route
//                               key={index}
//                               exact={item.exact}
//                               path={item.to}
//                             >
//                               {/* <h1>{item.name}</h1> */}
//                             </Route>
//                             {item.subMenus && item.subMenus.length > 0
//                               ? item.subMenus.map((subMenu, index) => (
//                                   <Route key={index} path={subMenu.to}>
//                                     {/* <h1>{subMenu.name}</h1> */}
//                                   </Route>
//                                 ))
//                               : null}
//                           </div>
//                         );

//                     })}

//                     <Switch>
//                       <Route path="/login" component={LoginForm} />
//                       <Route path="/registeruser" component={RegisterUser} />;
//                       <ProtectedRoute path="/search" component={Search} />
//                       <ProtectedRoute
//                         path="/register/:id"
//                         exact
//                         render={(props) => <Register {...props} user={user} />}
//                       />
//                       <ProtectedRoute
//                         path="/registerlist"
//                         component={registerlist}
//                       />
//                         <ProtectedRoute
//                         path="/lprrecord"
//                         component={LPRreport}
//                       />

//                       <ProtectedRoute
//                         path="/showdetail"
//                         component={Showdetail}
//                       />
//                         <ProtectedRoute
//                         path="/queueactual"
//                         component={QueueActual}
//                       />
//                       <ProtectedRoute
//                         path="/Reportchart"
//                         component={Reportchart}
//                       />
//                       <ProtectedRoute
//                         path="/Stackedcolumnchart"
//                         component={Stackedcolumnchart}
//                       />
//                       <ProtectedRoute
//                         path="/weightreport"
//                         component={Weightreport}
//                       />
//                       <ProtectedRoute
//                         path="/woodchipmonitor"
//                         component={Woodchipmonitor}
//                       />
//                       <ProtectedRoute
//                         // path="/woodmonitor"
//                         // component={Woodmonitor}
//                         path="/woodmonitor"
//                         component={QueueActual501}
//                       />
//                       <ProtectedRoute
//                         // path="/queuewoodchip"
//                         // component={Queuewoodchip}
//                         path="/queuewoodchip"
//                         component={QueuePlanWood}
//                       />
//                       <ProtectedRoute
//                         path="/reportsumary"
//                         component={Reportsummary}
//                       />
//                       <ProtectedRoute
//                         path="/receivecoal"
//                         component={Coalreceive}
//                       />
//                       <ProtectedRoute
//                         path="/CardQueueCall"
//                         component={CardQueueCall}
//                       />
//                         <ProtectedRoute
//                         path="/Renderdrivenprofile"
//                         component={Renderdrivenprofile}
//                       />
//                          <ProtectedRoute
//                         path="/Showtruckover"
//                         component={Showtruckover}
//                       />
//                             <ProtectedRoute
//                         path="/managebranch"
//                         component={Managebranch}
//                       />
//                              <ProtectedRoute
//                         path="/manageface"
//                         component={Manageface}
//                       />
//                       <ProtectedRoute
//                         path="/queuelist"
//                         component={Queuemonitor}
//                       />
//                         <ProtectedRoute
//                         path="/Weightreportbranch"
//                         component={Weightreportbranch}
//                       />
//                       <ProtectedRoute path="/editbranch" component={Editbranch}/>
//                       <ProtectedRoute path="/reportpower" component={Reportpower}/>
//                       <ProtectedRoute path="/editcar" component={Editcar}/>
//                       <ProtectedRoute path="/modaleditcar" component={Modaleditcar}/>
//                       <ProtectedRoute path="/editcustomer" component={Editcustormer}/>
//                       <ProtectedRoute path="/modaleditcustomer" component={Modaleditcustomer}/>
//                       <ProtectedRoute path="/modaleditproduct" component={Modaleditproduct}/>
//                       <ProtectedRoute path="/cardeditproduct" component={Cardeditproduct}/>
//                       <ProtectedRoute path="/cardeditdo" component={Cardeditdo}/>
//                       <ProtectedRoute path="/modaleditdo" component={Modaleditdo}/>
//                       <ProtectedRoute path="/modalapprove" component={Modalapprove}/>
//                       <ProtectedRoute path="/modalchangcustomer" component={Modalchangcustomer}/>
//                       <ProtectedRoute path="/changcustomer" component={Changcustomer}/>
//                       <ProtectedRoute path="/editobjective" component={Editobjective}/>
//                       <ProtectedRoute path="/editqueue" component={Editqueue}/>
//                       <ProtectedRoute path="/modaleditqueue" component={Modaleditqueue}/>
//                       <ProtectedRoute path="/mainweigthscale" component={Mainweigthscale}/>
//                       <ProtectedRoute path="/request" component={Request}/>
//                       <ProtectedRoute path="/requestall" component={Requestall}/>
//                       <ProtectedRoute path="/approve" component={Approve}/>
//                       <ProtectedRoute path="/allapprove" component={Allapprove}/>
//                       <ProtectedRoute path="/waitapprove" component={Waitapprove}/>
//                       <ProtectedRoute path="/okapprove" component={Okapprove}/>
//                       <ProtectedRoute path="/notapprove" component={Notapprove}/>
//                       <ProtectedRoute path="/viewrequest" component={Viewrequest}/>
//                       <Route path="/registeruser" component={RegisterUser} />;

//                       <Route path="/logout" component={Logout} />;
//                       {/* <Route path="/not-found" component={NotFound} /> */}
//                       <Redirect from="/" exact to="/search" />
//                       {/* <Redirect to="/not-found" /> */}
//                     </Switch>

//                     {/* <Switch>
//             <Route exact path={"/"}>
//               <Dashboard />
//             </Route>
//             <Route exact path={"/content"}>
//               <Content />
//             </Route>
//             <Route path={"/content/courses"}>
//               <Courses />
//             </Route>
//             <Route path={"/content/videos"}>
//               <Videos />
//             </Route>
//             <Route path={"/design"}>
//               <Design />
//             </Route>
//             <Route exact path={"/content-2"}>
//               <Content2 />
//             </Route>
//             <Route path={"/content-2/courses"}>
//               <Courses2 />
//             </Route>
//             <Route path={"/content-2/videos"}>
//               <Videos2 />
//             </Route>
//             <Route path={"/design-2"}>
//               <Design2 />
//             </Route>
//           </Switch> */}
//                   </div>
//                 ) : (
//                   <Switch>
//                     <Route path="/login" component={LoginForm} />
//                     <ProtectedRoute path="/search" component={Search} />
//                     <Route path="/logout" component={Logout} />;
//                     <Route path="/registeruser" component={RegisterUser} />;
//                     <Redirect from="/" exact to="/search" />
//                   </Switch>
//                 )}
//               </Router>
//             </div>
//           </BranchContext.Provider>
//         </PrivilegeContext.Provider>
//       </UserContext.Provider>
//     </StoreContextProvider>
//   );
// }

// export default App;
